export const BUTTON = 'button';
export const LINK = 'link';